import { gql } from 'apollo-angular';

export const GET_OUTBOUND_CALLS_LIST = gql`
  query ($criteria: OutboundCallListCriteria!) {
    outboundCallList(criteria: $criteria) {
      totalResults
      results {
        id
        externalId
        phoneNumber
        status
        conversationResult
        summary
        transcription
        tags
        createdAt
        duration
        closedBy
        transferred
        failedReason
        customer {
          id
          name
        }
      }
    }
  }
`;
